import classNames from 'classnames';

import { ClassNameType } from 'interfaces';

const styles = {
  component: (
    className: ClassNameType,
  ) => className,
  toggleSection: classNames(
    'sm:flex',
    'justify-between',
    'content-center',
    '!mt-5',
  ),
  toggleButton1: classNames(
    '!mr-2',
    'capitalize',
  ),
  toggleButton2: classNames(
    'capitalize',
  ),
  typeToggle: classNames(
    '!mt-0',
    '!mb-6',
    'sm:!my-5',
    'sm:flex',
    'justify-between',
  ),
  unitToggle: classNames(
    '!mt-0',
    '!mb-6',
    'sm:!my-5',
    'sm:!flex',
  ),
  toggleUnitButton1: classNames(
    '!mr-2',
    'lowercase',
  ),
  toggleUnitButton2: classNames(
    'lowercase',
  ),
  section: classNames(
    '!my-10',
  ),
};

export default styles;
